export default function nonMasterCourseMapping(
  state = {
    unmappedOnly: true,
    hasStudentEnrolling: true,
    searchedCourses: [],
    searching: false,
    retrievingNonMasterCourses: false,
    nonMasterCourses: {},
    nonMasterCourseSearchString: undefined,
    selectedCourseId: null,
  },
  action,
) {
  switch (action.type) {
    case 'NON_MASTER_COURSE/POPULATE_SEARCH_COURSES':
      return {
        ...state,
        searchedCourses: action.courses,
      };
    case 'NON_MASTER_COURSE/SET_SEARCHING':
      return {
        ...state,
        searching: action.mode,
      };
    case 'NON_MASTER_COURSE/TOGGLE_MAP_TYPE':
      return {
        ...state,
        unmappedOnly: !state.unmappedOnly,
      };
    case 'NON_MASTER_COURSE/TOGGLE_HAS_STUDENT_ENROLLING':
      return {
        ...state,
        hasStudentEnrolling: !state.hasStudentEnrolling,
      };
    case 'NON_MASTER_COURSE/SET_RETRIEVING_COURSES_BUSY':
      return {
        ...state,
        retrievingNonMasterCourses: action.mode,
      };
    case 'NON_MASTER_COURSE/POPULATE_NON_MASTER_COURSES':
      return {
        ...state,
        nonMasterCourses: {
          ...action.courses,
          results: action.combineResults
            ? [
                ...(state.nonMasterCourses.results || []),
                ...action.courses.results,
              ]
            : action.courses.results,
        },
        nonMasterCourseSearchString: action.search,
      };
    case 'NON_MASTER_COURSE/SET_SELECTED_COURSE':
      return {
        ...state,
        selectedCourseId: action.selectedCourseId,
      };
    case 'NON_MASTER_COURSE/RESET_SEARCHED_COURSES':
      return {
        ...state,
        searchedCourses: [],
      };
    default:
      return state;
  }
}
